import { DetailedHTMLProps, FC, FocusEvent, SelectHTMLAttributes, useState } from 'react';
import { ListFieldProps, ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

interface TspSelectProps
  extends DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
  jssMetadata: ValueFieldProps | ListFieldProps;
}

const TspSelect: FC<TspSelectProps> = ({ jssMetadata, ...htmlProps }) => {
  const { field, errors, tracker } = jssMetadata;
  const [hasFocus, setHasFocus] = useState(false);
  const hasAnyError = !!errors?.length;
  const isPlaceholder = !htmlProps.value;

  const onFocus = (event: FocusEvent<HTMLSelectElement>) => {
    tracker.onFocusField(field, event?.target?.value);
    setHasFocus(true);
  };

  const onBlur = (event: FocusEvent<HTMLSelectElement>) => {
    tracker.onBlurField(field, event?.target?.value);
    setHasFocus(false);
  };

  return (
    <select
      {...htmlProps}
      className={classNames(
        'tsp-select h-[3.25rem] w-full appearance-none rounded-lg border px-4 py-3 pr-10 text-lg outline-none',
        'border-[var(--tsp-border)] bg-[var(--tsp-surface)] text-[var(--tsp-text-primary)]',
        hasFocus && 'border-[var(--tsp-primary)]',
        hasAnyError && 'border-error bg-error/20',
        isPlaceholder && 'text-[var(--tsp-placeholder)]',
        htmlProps.className
      )}
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23B9B9B9' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 1rem center',
      }}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {htmlProps.children}
    </select>
  );
};

export default TspSelect;
